module.exports = __webpack_public_path__ + "img/icon_map_shanchu.621fb429.svg";